import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import PrimeVue from 'primevue/config/PrimeVue';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
// import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import BlockUI from 'primevue/blockui';
import xlsx from "xlsx"
import jspdf from "jspdf"
// import jsbarcode from "jsbarcode"
import JsonExcel from "./views/JsonExcel.vue";

import 'primevue/resources/themes/nova/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import './assets/layout/layout.scss';
import { createProvider, onLogin, onLogout, getClient } from './vue-apollo'

import underscore from 'vue-underscore';

import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true })


// Vue.use(PrimeVue, {ripple: true});

Vue.use(ToastService);
Vue.directive('tooltip', Tooltip);
Vue.use(require('vue-moment'));
Vue.use(underscore)
Vue.use(xlsx);
Vue.use(jspdf);
// Vue.use(jsbarcode);

Vue.config.productionTip = false;

Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Button', Button);
Vue.component('BlockUI', BlockUI);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Carousel', Carousel);
Vue.component('Chart', Chart);
Vue.component('Checkbox', Checkbox);
Vue.component('Chips', Chips);
Vue.component('Column', Column);
Vue.component('ContextMenu', ContextMenu);
Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('Editor', Editor);
// Vue.component('Fieldset', Fieldset);
Vue.component('FileUpload', FileUpload);
Vue.component('FullCalendar', FullCalendar);
Vue.component('Inplace', Inplace);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('InputMask', InputMask);
Vue.component('InputNumber', InputNumber);
Vue.component('Listbox', Listbox);
Vue.component('MegaMenu', MegaMenu);
Vue.component('Menu', Menu);
Vue.component('Menubar', Menubar);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('OrderList', OrderList);
Vue.component('OrganizationChart', OrganizationChart);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('PanelMenu', PanelMenu);
Vue.component('Password', Password);
Vue.component('PickList', PickList);
Vue.component('ProgressBar', ProgressBar);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('RadioButton', RadioButton);
Vue.component('Rating', Rating);
Vue.component('SelectButton', SelectButton);
Vue.component('Slider', Slider);
Vue.component('Sidebar', Sidebar);
Vue.component('SplitButton', SplitButton);
Vue.component('Steps', Steps);
Vue.component('TabMenu', TabMenu);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('TieredMenu', TieredMenu);
Vue.component('Toast', Toast);
Vue.component('Toolbar', Toolbar);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Tree', Tree);
Vue.component('TreeTable', TreeTable);
Vue.component('TriStateCheckbox', TriStateCheckbox);
// Vue.component('ImportDocumentDialog', ImportDocumentDialog);
Vue.component("ExportExcel", JsonExcel);

import * as firebase from 'firebase/app'
import store from './store'
import config from './config/index'

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: config.googleMaps(),
  installComponents: true
});


// Initialize Firebase
firebase.initializeApp(config.fireBase());
firebase.analytics();
firebase.auth().onAuthStateChanged(function (user) {
  // console.log(user)
  if (user) {
    store.commit('setUser', user.uid)
    store.commit('setIsLoggedIn', true)
  } else {
    // User is signed out.
    // ...
    // console.log('User logout')
    store.commit('setUser', null)
    store.commit('setIsLoggedIn', false)
    store.commit('setToken', null)
    onLogout(null)
  }
})

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

let refreshTokenInterval = null;

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = await firebase.getCurrentUser()
  let token = store.getters.token
  if (currentUser && token == null) {
    token = await currentUser.getIdToken()
    // console.log(token)
    store.commit('setToken', token)
    onLogin(null, token)
  }
  if (refreshTokenInterval == null) {
    //khác Thêm bảng giá cơ quan thì Refresh => vì refesh sẽ mất dữ liệu
    if (window.location.href.indexOf("admin/list-organ_pricelist/add") < 0){
      refreshTokenInterval = setInterval(async function () {
        console.log("Refresh Token");
        token = await currentUser.getIdToken();
        store.commit("setToken", token);
        onLogin(null, token);
      }, 1000 * 60);
    }
  }
  
  if (requiresAuth && !currentUser) {
    next('/auth/login')
  } else {
    next()
  }
})

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
Vue.use(CoolLightBox)

import i18n from './i18n'
import {helpers} from './helpers'
import gql from "graphql-tag";
import constants from './common/Constants';
import CoreService from "./common/CoreService";
import commonFuction from "./common/Common";

Vue.prototype.$constants = constants.getConstans();
Vue.prototype.$CoreService = CoreService;
Vue.prototype.$commonFuction = commonFuction;

new Vue({
  router,
  apolloProvider: createProvider(),
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
Vue.prototype.$helpers = helpers

// Mỗi lần load lại trang (F5), lấy lại quyền mới nhất từ DB thay vì chỉ dùng bản cache lúc đăng nhập
async function refreshGroupPermission() {
  try {
    if (store.getters.role && store.getters.role !== 'admin' && store.getters.group_permission_id) {
      let client = getClient();
      let query = `query MyQuery($id: Int) {
        group_permission_detail(where: {group_permission_id: {_eq: $id}}) {
          view
          list
          export
          edit
          delete
          add
          delete_group
          permission {
            key
          }
        }
      }`;
      const res = await client.query({
        query: gql(query),
        variables: { id: store.getters.group_permission_id },
        fetchPolicy: 'no-cache',
      });
      if (res.data && res.data.group_permission_detail && res.data.group_permission_detail.length > 0) {
        var newGroupPermission = {};
        for (let i = 0; i < res.data.group_permission_detail.length; i++) {
          const e = res.data.group_permission_detail[i];
          newGroupPermission[e.permission.key] = {
            add: e.add,
            edit: e.edit,
            export: e.export,
            delete: e.delete,
            list: e.list,
            view: e.view,
            delete_group: e.delete_group,
          };
        }
        store.commit('setGroupPermission', newGroupPermission);
      }
    }
  } catch (error) {
    console.error('refreshGroupPermission error:', error);
  }
}
refreshGroupPermission();

let tesst = location.href.slice(location.href.length - 5, location.href.length)
  let abc = 0
  // console.log('href', tesst)
  if (tesst !== 'login' && abc === 0 && store.getters.role !== 'admin') {
    // console.log('user',store.getters.user)
    setInterval(async function () {
      console.log('router name', router.history.current.name)
      let router_name = router.history.current.name
      let key_permission = ''
      let code_permission = ''

      if (router_name == "importDoc") {
        key_permission = "insert_document"
        code_permission = "list"
      }
      if (router_name == "addDoc") {
        key_permission = "insert_document"
        code_permission = "add"
      }
      if (router_name == "editDoc") {
        key_permission = "insert_document"
        code_permission = "edit"
      }
      if (router_name == "viewDoc") {
        key_permission = "insert_document"
        code_permission = "view"
      }
      if (router_name == "lstDoc") {
        key_permission = "list_document"
        code_permission = "list"
      }
      if (router_name == "editLstDoc") {
        key_permission = "list_document"
        code_permission = "edit"
      }
      if (router_name == "stateDetail") {
        key_permission = "detail_document"
        code_permission = "list"
      }
      if (router_name == "stateReturnCourt") {
        key_permission = "court_document"
        code_permission = "list"
      }
      if (router_name == "editStateReturnCourt") {
        key_permission = "court_document"
        code_permission = "edit"
      }
      if (router_name == "computeSalary") {
        key_permission = "confirm_salary_document"
        code_permission = "list"
      }
      if (router_name == "editComputeSalary") {
        key_permission = "confirm_salary_document"
        code_permission = "edit"
      }
      if (router_name == "computeSalaryOutbound") {
        key_permission = "list_document_province"
        code_permission = "list"
      }
      if (router_name == "parollEmployee") {
        key_permission = "employee_payroll"
        code_permission = "list"
      }
      if (router_name == "reportCompleteLate") {
        key_permission = "report_late_done"
        code_permission = "list"
      }
      if (router_name == "editReportCompleteLate") {
        key_permission = "report_late_done"
        code_permission = "edit"
      }
      if (router_name == "reportUnCompleteLate") {
        key_permission = "report_late_undone"
        code_permission = "list"
      }
      if (router_name == "editReportUnCompleteLate") {
        key_permission = "report_late_undone"
        code_permission = "edit"
      }
      if (router_name == "reportComparison") {
        key_permission = "report_compare"
        code_permission = "list"
      }
      if (router_name == "notification") {
        key_permission = "push_notification"
        code_permission = "list"
      }
      if (router_name == "addNotification") {
        key_permission = "push_notification"
        code_permission = "add"
      }
      if (router_name == "holiday_setting") {
        key_permission = "holiday_setting"
        code_permission = "list"
      }
      if (router_name == "addholiday_setting") {
        key_permission = "holiday_setting"
        code_permission = "add"
      }
      if (router_name == "editholiday_setting") {
        key_permission = "holiday_setting"
        code_permission = "edit"
      }
      if (router_name == "addstatus_tongdat") {
        key_permission = "delay_document_setting"
        code_permission = "add"
      }
      if (router_name == "users_dpv") {
        key_permission = "list_coordinator"
        code_permission = "list"
      }
      if (router_name == "addusers_dpv") {
        key_permission = "list_coordinator"
        code_permission = "add"
      }
      if (router_name == "editusers_dpv") {
        key_permission = "list_coordinator"
        code_permission = "edit"
      }

      if (router_name == "court_account") {
        key_permission = "list_court_account"
        code_permission = "list"
      }
      if (router_name == "addcourt_account") {
        key_permission = "list_court_account"
        code_permission = "add"
      }
      if (router_name == "editcourt_account") {
        key_permission = "list_court_account"
        code_permission = "edit"
      }

      if (router_name == "users_tdv") {
        key_permission = "list_circulator"
        code_permission = "list"
      }
      if (router_name == "addusers_tdv") {
        key_permission = "list_circulator"
        code_permission = "add"
      }
      if (router_name == "editusers_tdv") {
        key_permission = "list_circulator"
        code_permission = "edit"
      }
      if (router_name == "office_tpl") {
        key_permission = "list_office"
        code_permission = "list"
      }
      if (router_name == "addoffice_tpl") {
        key_permission = "list_office"
        code_permission = "add"
      }
      if (router_name == "editoffice_tpl") {
        key_permission = "list_office"
        code_permission = "edit"
      }
      if (router_name == "office_agency") {
        key_permission = "list_organization"
        code_permission = "list"
      }
      if (router_name == "addoffice_agency") {
        key_permission = "list_organization"
        code_permission = "add"
      }
      if (router_name == "editoffice_agency") {
        key_permission = "list_organization"
        code_permission = "edit"
      }
      if (router_name == "area") {
        key_permission = "list_area"
        code_permission = "list"
      }
      if (router_name == "addarea") {
        key_permission = "list_area"
        code_permission = "add"
      }
      if (router_name == "editarea") {
        key_permission = "list_area"
        code_permission = "edit"
      }
      if (router_name == "office_vplk") {
        key_permission = "list_affiliate_office"
        code_permission = "list"
      }
      if (router_name == "addoffice_vplk") {
        key_permission = "list_affiliate_office"
        code_permission = "add"
      }
      if (router_name == "editoffice_vplk") {
        key_permission = "list_affiliate_office"
        code_permission = "edit"
      }
      if (router_name == "salary_pricelist") {
        key_permission = "salary_pricelist"
        code_permission = "list"
      }
      if (router_name == "addsalary_pricelist") {
        key_permission = "salary_pricelist"
        code_permission = "add"
      }
      if (router_name == "editsalary_pricelist") {
        key_permission = "salary_pricelist"
        code_permission = "edit"
      }
      if (router_name == "salary_pricelist_province") {
        key_permission = "salary_pricelist_province"
        code_permission = "list"
      }
      if (router_name == "addsalary_pricelist_province") {
        key_permission = "salary_pricelist_province"
        code_permission = "add"
      }
      if (router_name == "editsalary_pricelist_province") {
        key_permission = "salary_pricelist_province"
        code_permission = "edit"
      }
      if (router_name == "organ_pricelist_province") {
        key_permission = "organ_pricelist_province"
        code_permission = "list"
      }
      if (router_name == "organ_pricelist") {
        key_permission = "organ_pricelist"
        code_permission = "list"
      }
      if (router_name == "addorgan_pricelist") {
        key_permission = "organ_pricelist"
        code_permission = "add"
      }
      if (router_name == "editorgan_pricelist") {
        key_permission = "organ_pricelist"
        code_permission = "edit"
      }



      if (key_permission !== '' && code_permission !== '') {
        let client = getClient();
        let query = `query MyQuery($key: String , $id: Int ) {
          group_permission_detail(where: {permission: {key: {_eq: $key}}, group_permission_id: {_eq: $id}}) {
            ${code_permission}
          }
        }
      `;
      console.log('query', query)
      await client
        .query({
          query: gql(query),
          variables: {
            id: store.getters.group_permission_id,
            key: key_permission
          },
          fetchPolicy: 'no-cache',
        })
        .then((res) => {
          if (res.data.group_permission_detail.length > 0) {
            console.log('permission', res.data.group_permission_detail)
            if (res.data.group_permission_detail[0][code_permission] == false) {
              var editDocKeys = ['insert_document', 'list_document', 'court_document', 'confirm_salary_document', 'report_late_done', 'report_late_undone'];
              var hasEditAfterSalaryPermission = store.getters.group_permission && store.getters.group_permission.edit_document_after_salary && store.getters.group_permission.edit_document_after_salary.edit == true;
              if (code_permission == 'edit' && editDocKeys.indexOf(key_permission) !== -1 && hasEditAfterSalaryPermission) {
                // Có quyền "Chỉnh sửa VB khi đã tính lương" thì không đá về 404
              } else {
                abc = 1
                setInterval(
                  router.push({name: '404'}), 3000
                )
              }
            }
          }
        });
      }
 
    }, 3000);
  }